module.exports = __webpack_public_path__ + "static/media/logo-green.68fe2f77.svg";